import { Link } from "react-router-dom";
import { MapPin, Mail, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_encounter-god-change/artifacts/rn5hnru9_CFM%20Logo.jpg";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B1D2E] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #E4E1D8 0%, transparent 40%), radial-gradient(circle at 80% 80%, #123F33 0%, transparent 50%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="The Potter's House logo"
                className="w-12 h-12 object-contain"
                style={{ mixBlendMode: "screen" }}
              />
              <span className="font-serif text-2xl">The Potter's House</span>
            </div>
            <div className="text-xs tracking-[0.22em] uppercase text-white/50 -mt-2 mb-6">Christian Fellowship Ministries</div>
            <p className="text-white/70 text-base leading-relaxed max-w-md">
              A local church in DeLand, Florida — faithfully preaching the life-changing message of Jesus Christ. Come join us.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-5">
              Visit
            </div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#E4E1D8]" />
                <span>340B E New York Ave<br />DeLand, FL 32724</span>
              </li>
              <li className="flex gap-3">
                <Mail className="w-4 h-4 mt-0.5 shrink-0 text-[#E4E1D8]" />
                <span>delandpottershouse@gmail.com</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-white/50 mb-5">
              Service Times
            </div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-[#E4E1D8]" />
                <span>Sunday · 11:00 AM & 7:00 PM</span>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-[#E4E1D8]" />
                <span>Wednesday · 7:00 PM</span>
              </li>
            </ul>
            <div className="mt-6 flex gap-2 flex-wrap">
              <Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4" data-testid="footer-about">About</Link>
              <span className="text-white/30">·</span>
              <Link to="/events" className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4" data-testid="footer-events">Events</Link>
              <span className="text-white/30">·</span>
              <Link to="/testimonies" className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4" data-testid="footer-testimonies">Testimonies</Link>
              <span className="text-white/30">·</span>
              <Link to="/give" className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4" data-testid="footer-give">Give</Link>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} The Potter's House Christian Church · DeLand, FL
          </div>
          <div className="text-xs text-white/50 italic font-serif">
            "Go into all the world and preach the Gospel." — Mark 16:15
          </div>
        </div>
      </div>
    </footer>
  );
}
